import ReportPage from './ReportPage'

export default function HistoricoPrecoEstoqueReport({className = ''}: {className?: string}) {
  return <ReportPage type='preco_estoque_hist' className={className} />
}
